import useNextPagesPaths from "./app-pages-transition/useNextPagesPaths";

export function useCurrentRoute(): string {
  const {asPath} = useNextPagesPaths();

  if (asPath === "/") return "index";

  return asPath.slice(1);
}
